export const ArrowUp = require('./arrow-up.png');
export const ArrowDown = require('./arrow-down.png');

export const Orders = require('./orders.png');
export const Account = require('./account.png');
export const Favorites = require('./fav.png');
export const ABO = require('./abo.png');
export const Promos = require('./promos.png');
export const Purchase = require('./purchase.png');
export const Event = require('./event.png');
export const Help = require('./help.png');
export const Login = require('./login.png');
export const Logout = require('./logout.png');